import {
  ASSET_AGGREGATE,
  COMPANY_AGGREGATE,
  COUNTRY_AGGREGATE,
} from '../../../pages/PortfolioAnalysis/PortfolioGraphing/utils';

const VALUATIONS_LINK = {
  action: 'valuations',
  label: 'Valuations',
};
const ASSET_VALUATIONS_LINK = {
  action: 'asset-valuations',
  label: 'Valuations',
};
const OIL_AND_GAS_MAP_LINK = { action: 'oil-and-gas', label: 'O&G Map' };
const COUNTRY_OVERVIEW_LINK = { action: 'country-overview', label: 'Country Overviews' };
const VALUATION_DOWNLOAD = {
  action: 'download-valuation-model',
  label: 'Valuation Model',
};
const ASSET_REPORT_DOWNLOAD = { action: 'download-asset-report', label: 'Asset Report' };
const COUNTRY_REPORT_DOWNLOAD = { action: 'download-country-report', label: 'Country Report' };

export const AGGREGATE_INFO = {
  [COUNTRY_AGGREGATE.name]: {
    links: [VALUATIONS_LINK, OIL_AND_GAS_MAP_LINK, COUNTRY_OVERVIEW_LINK],
    downloads: [COUNTRY_REPORT_DOWNLOAD],
  },
  [ASSET_AGGREGATE.name]: {
    links: [ASSET_VALUATIONS_LINK, OIL_AND_GAS_MAP_LINK, COUNTRY_OVERVIEW_LINK],
    downloads: [VALUATION_DOWNLOAD, ASSET_REPORT_DOWNLOAD, COUNTRY_REPORT_DOWNLOAD],
  },
  [COMPANY_AGGREGATE.name]: {
    links: [VALUATIONS_LINK],
    downloads: [],
  },
};
